/* RESPONSIBLE TEAM: team-proactive-support */
import Model, { attr } from '@ember-data/model';

export default class SavedView extends Model {
  @attr('string') name;
  @attr('number') scope;
  @attr('string') avatarEmoji;
  @attr() savedViewData;
}
